// frontend/src/utils/englishIpa.ts
export interface IpaWord {
  surface: string; // 原始单词，如 "international"
  ipa?: string;    // IPA，如 "/ˌɪn.təˈnæʃ.ən.əl/"
}

// 简单的示例词典（后续可以扩展或换成真实词典库）
const SIMPLE_IPA_DICT: Record<string, string> = {
  // 小写 key → IPA 字符串
  "international": "/ˌɪn.təˈnæʃ.ən.əl/",
  "elevator": "/ˈɛlɪˌveɪtər/",
  "people": "/ˈpiːpəl/",
  "language": "/ˈlæŋɡwɪdʒ/",
  "customer": "/ˈkʌstəmər/",
  "door": "/dɔːr/",
  "the": "/ðə/",
  "a": "/ə/",
  "an": "/ən/",
  "and": "/ænd/",
  "or": "/ɔːr/",
  "to": "/tuː/",
  "of": "/ʌv/",
  "in": "/ɪn/",
  "on": "/ɒn/",
  "at": "/æt/",
  "for": "/fɔːr/",
  "with": "/wɪð/",
  "from": "/frʌm/",
  "by": "/baɪ/",
  "about": "/əˈbaʊt/",
  "into": "/ˈɪntuː/",
  "through": "/θruː/",
  "during": "/ˈdʊrɪŋ/",
  "including": "/ɪnˈkluːdɪŋ/",
  "against": "/əˈɡenst/",
  "among": "/əˈmʌŋ/",
  "throughout": "/θruːˈaʊt/",
  "despite": "/dɪˈspaɪt/",
  "towards": "/tɔːrdz/",
  "upon": "/əˈpɒn/",
  "concerning": "/kənˈsɜːrnɪŋ/",
  "considering": "/kənˈsɪdərɪŋ/",
  "regarding": "/rɪˈɡɑːrdɪŋ/",
  "following": "/ˈfɒləʊɪŋ/",
  "across": "/əˈkrɒs/",
  "behind": "/bɪˈhaɪnd/",
  "beyond": "/bɪˈjɒnd/",
  "plus": "/plʌs/",
  "except": "/ɪkˈsept/",
  "but": "/bʌt/",
  "up": "/ʌp/",
  "out": "/aʊt/",
  "off": "/ɒf/",
  "over": "/ˈəʊvər/",
  "under": "/ˈʌndər/",
  "again": "/əˈɡen/",
  "further": "/ˈfɜːðər/",
  "then": "/ðen/",
  "once": "/wʌns/",
  "here": "/hɪər/",
  "when": "/wen/",
  "where": "/weər/",
  "why": "/waɪ/",
  "how": "/haʊ/",
  "all": "/ɔːl/",
  "each": "/iːtʃ/",
  "few": "/fjuː/",
  "more": "/mɔːr/",
  "most": "/məʊst/",
  "other": "/ˈʌðər/",
  "some": "/sʌm/",
  "such": "/sʌtʃ/",
  "no": "/nəʊ/",
  "nor": "/nɔːr/",
  "not": "/nɒt/",
  "only": "/ˈəʊnli/",
  "own": "/əʊn/",
  "same": "/seɪm/",
  "so": "/səʊ/",
  "than": "/ðæn/",
  "too": "/tuː/",
  "very": "/ˈveri/",
  "can": "/kæn/",
  "will": "/wɪl/",
  "just": "/dʒʌst/",
  "don": "/dɒn/",
  "should": "/ʃʊd/",
  "now": "/naʊ/",
  "get": "/ɡet/",
  "also": "/ˈɔːlsəʊ/",
  "use": "/juːz/",
  "two": "/tuː/",
  "its": "/ɪts/",
  "who": "/huː/",
  "oil": "/ɔɪl/",
  "sit": "/sɪt/",
  "set": "/set/",
  "run": "/rʌn/",
  "eat": "/iːt/",
  "sea": "/siː/",
  "eye": "/aɪ/",
  "job": "/dʒɒb/",
  "yet": "/jet/",
  "end": "/end/",
  "bad": "/bæd/",
  "old": "/əʊld/",
  "let": "/let/",
  "put": "/pʊt/",
  "say": "/seɪ/",
  "she": "/ʃiː/",
  "her": "/hɜːr/",
  "man": "/mæn/",
  "day": "/deɪ/",
  "has": "/hæz/",
  "look": "/lʊk/",
  "time": "/taɪm/",
  "if": "/ɪf/",
  "many": "/ˈmeni/",
  "them": "/ðem/",
  "these": "/ðiːz/",
  "would": "/wʊd/",
  "make": "/meɪk/",
  "like": "/laɪk/",
  "him": "/hɪm/",
  "write": "/raɪt/",
  "go": "/ɡəʊ/",
  "see": "/siː/",
  "number": "/ˈnʌmbər/",
  "way": "/weɪ/",
  "could": "/kʊd/",
  "my": "/maɪ/",
  "first": "/fɜːst/",
  "water": "/ˈwɔːtər/",
  "been": "/biːn/",
  "call": "/kɔːl/",
  "find": "/faɪnd/",
  "down": "/daʊn/",
  "did": "/dɪd/",
  "come": "/kʌm/",
  "made": "/meɪd/",
  "may": "/meɪ/",
  "part": "/pɑːt/",
};

const wordSplitRegex = /(\b[^\s]+\b)|([^\w\s])/g;

/** 归一化英文单词：转小写，去掉前后标点 */
export function normalizeEnglishWord(surface: string): string {
  return surface
    .toLowerCase()
    .replace(/^[^a-z]+/g, "")
    .replace(/[^a-z]+$/g, "");
}

/** 查词典，返回 IPA 或 undefined */
export function lookupIpa(surface: string): string | undefined {
  const normalized = normalizeEnglishWord(surface);
  if (!normalized) return undefined;
  return SIMPLE_IPA_DICT[normalized];
}

/** 将整句英文拆成词+标点，并为每个词附上 IPA（如果有） */
export function textToIpaWords(text: string): IpaWord[] {
  const result: IpaWord[] = [];
  const matches = text.match(wordSplitRegex);
  if (!matches) return result;

  for (const token of matches) {
    if (!token) continue;
    const ipa = lookupIpa(token);
    result.push({ surface: token, ipa });
  }

  return result;
}
